// Effects
import { all, call, put, takeLatest } from 'redux-saga/effects';

// Constants
import {
  ADD_MEMBER,
  ADD_MEMBER_FAILURE,
  ADD_MEMBER_SUCCESS,
  ARCHIVE_MEMBERS,
  ARCHIVE_MEMBERS_FAILURE,
  ARCHIVE_MEMBERS_SUCCESS,
  DELETE_MEMBER_INVITATION,
  DELETE_MEMBER_INVITATION_FAILURE,
  DELETE_MEMBER_INVITATION_SUCCESS,
  GET_INVITED_MEMBERS,
  GET_INVITED_MEMBERS_FAILURE,
  GET_INVITED_MEMBERS_SUCCESS,
  GET_MEMBERS,
  GET_MEMBERS_FAILURE,
  GET_MEMBERS_SUCCESS,
  GET_MEMBER_DETAILS,
  GET_MEMBER_DETAILS_FAILURE,
  GET_MEMBER_DETAILS_SUCCESS,
  GET_MEMBER_MONTHLY_EARNING,
  GET_MEMBER_MONTHLY_EARNING_FAILURE,
  GET_MEMBER_MONTHLY_EARNING_SUCCESS,
  GET_MEMBER_WEEKLY_EARNING,
  GET_MEMBER_WEEKLY_EARNING_FAILURE,
  GET_MEMBER_WEEKLY_EARNING_SUCCESS,
  INVITE_MEMBER,
  INVITE_MEMBER_FAILURE,
  INVITE_MEMBER_SUCCESS,
  REMOVE_MEMBER,
  REMOVE_MEMBER_FAILURE,
  REMOVE_MEMBER_SUCCESS, // payment configuration
  SET_PAYMENT_CONFIGURATION,
  SET_PAYMENT_CONFIGURATION_FAILURE,
  SET_PAYMENT_CONFIGURATION_SUCCESS,
  UPDATE_MEMBER,
  UPDATE_MEMBER_FAILURE,
  UPDATE_MEMBER_SUCCESS,
  UPDATE_PAYMENT_CONFIGURATION,
  UPDATE_PAYMENT_CONFIGURATION_FAILURE,
  UPDATE_PAYMENT_CONFIGURATION_SUCCESS,
  BULK_UPDATE_EMPLOYEE_TYPE,
  BULK_UPDATE_EMPLOYEE_TYPE_FAILURE,
  BULK_UPDATE_EMPLOYEE_TYPE_SUCCESS,
  GET_PENDING_REQUESTS,
  GET_PENDING_REQUESTS_SUCCESS,
  GET_PENDING_REQUESTS_FAILURE,
  REQUEST_UPDATE_EMPLOYEE_TYPE,
  REQUEST_UPDATE_EMPLOYEE_TYPE_SUCCESS,
  REQUEST_UPDATE_EMPLOYEE_TYPE_FAILURE,
  BULK_UPDATE_FROM_PENDING_REQUESTS,
  BULK_UPDATE_FROM_PENDING_REQUESTS_SUCCESS,
  BULK_UPDATE_FROM_PENDING_REQUESTS_FAILURE,
} from '../../modules/constants';
// Service
import { defaultApi } from '../../utils/axiosApi';

//Handle login request

export function* getMembersList({ payload }) {
  const { page, name, office_id, role, user_code } = payload;
  try {
    const url = `/albait/users/?page=${page}${name ? `&name=${name}` : ''}${office_id ? `&office_id=${office_id}` : ''
      }${role ? `&role=${role}` : ''}${user_code ? `&user_code=${user_code}` : ''}`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_MEMBERS_SUCCESS,
      payload: { data: response, notify: 'GET' },
    });
  } catch (err) {
    yield put({
      type: GET_MEMBERS_FAILURE,
      payload: err,
    });
  }
}

export function* getInvitedMembersList({ payload }) {
  const { organization_id } = payload;
  try {
    const url = `${organization_id}/members/invitations/`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_INVITED_MEMBERS_SUCCESS,
      payload: { data: response, notify: 'GET' },
    });
  } catch (err) {
    yield put({
      type: GET_INVITED_MEMBERS_FAILURE,
      payload: err,
    });
  }
}

export function* inviteMember({ payload }) {
  const { organization_id, resend, ...details } = payload;
  try {
    const url = `${organization_id}/members/invitations/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: INVITE_MEMBER_SUCCESS,
      payload: { data: response, resend, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: INVITE_MEMBER_FAILURE,
      payload: err,
    });
  }
}

export function* deleteMemberInvitation({ payload }) {
  const { organization_id, invitation_id } = payload;
  try {
    const url = `${organization_id}/members/invitations/${invitation_id}/`;
    const method = 'DELETE';
    const response = yield defaultApi(url, method);
    yield call(getInvitedMembersList, { payload });
    yield put({
      type: DELETE_MEMBER_INVITATION_SUCCESS,
      payload: { data: response, notify: 'DELETE' },
    });
  } catch (err) {
    yield put({
      type: DELETE_MEMBER_INVITATION_FAILURE,
      payload: err,
    });
  }
}

export function* getMemberDetails({ payload }) {
  const { user_id } = payload;
  try {
    const url = `/albait/users/${user_id}/`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_MEMBER_DETAILS_SUCCESS,
      payload: { data: response, notify: 'GET' },
    });
  } catch (err) {
    yield put({
      type: GET_MEMBER_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* getMemberWeeklyEarning({ payload }) {
  const { organization_id, user_id } = payload;
  try {
    const url = `${organization_id}/members/${user_id}/earnings/week/`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_MEMBER_WEEKLY_EARNING_SUCCESS,
      payload: { data: response, notify: 'GET' },
    });
  } catch (err) {
    yield put({
      type: GET_MEMBER_WEEKLY_EARNING_FAILURE,
      payload: err,
    });
  }
}

export function* getMemberMonthlyEarning({ payload }) {
  const { organization_id, user_id } = payload;
  try {
    const url = `${organization_id}/members/${user_id}/earnings/month/`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_MEMBER_MONTHLY_EARNING_SUCCESS,
      payload: { data: response, notify: 'GET' },
    });
  } catch (err) {
    yield put({
      type: GET_MEMBER_MONTHLY_EARNING_FAILURE,
      payload: err,
    });
  }
}

export function* handleCreateMember({ payload }) {
  try {
    const {
      first_name,
      last_name,
      office,
      email,
      password,
      role,
      user_code,
      phone,
      device,
      sending_credential_email,
      image,
      mac_address,
      region,
    } = payload;
    const data = new FormData();
    data.append('first_name', first_name);
    data.append('last_name', last_name);
    data.append('office', office);
    data.append('email', email);
    data.append('password', password);
    data.append('role', role);
    data.append('user_code', user_code);
    data.append('phone', phone);
    data.append('device', device);
    data.append('sending_credential_email', sending_credential_email);
    data.append('mac_address', mac_address);
    if (image) {
      data.append('image', image);
    }
    if (region !== undefined) {
      data.append('region', region);
    }

    const url = `/albait/users/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, data);
    yield put({
      type: ADD_MEMBER_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: ADD_MEMBER_FAILURE,
      payload: err,
    });
  }
}

export function* updateMemberRequest({ payload }) {
  try {
    const {
      user_id,
      first_name,
      last_name,
      office,
      email,
      sending_credential_email,
      device,
      password,
      role,
      user_code,
      phone,
      image,
      geofence_time_clock,
      clockin_selfie,
      mac_address,
      region,
    } = payload;
    // console.log(payload);
    const data = new FormData();
    if (first_name) {
      data.append('first_name', first_name);
    }
    if (last_name !== undefined) {
      data.append('last_name', last_name);
    }
    if (office) {
      data.append('office', office);
    }
    if (email) {
      data.append('email', email);
    }
    if (sending_credential_email) {
      data.append('sending_credential_email', sending_credential_email);
    }
    if (device) {
      data.append('device', device);
    }
    if (password) {
      data.append('password', password);
    }
    if (role) {
      data.append('role', role);
    }
    if (user_code) {
      data.append('user_code', user_code);
    }
    if (phone) {
      data.append('phone', phone);
    }

    if (image !== undefined) {
      data.append('image', image);
    }

    if (geofence_time_clock !== undefined) {
      data.append('geofence_time_clock', geofence_time_clock);
    }
    if (clockin_selfie !== undefined) {
      data.append('clockin_selfie', clockin_selfie);
    }
    if (mac_address !== undefined) {
      data.append('mac_address', mac_address);
    }
    if (region !== undefined) {
      data.append('region', region);
    }

    const url = `/albait/users/${user_id}/`;
    const method = 'PATCH';
    const response = yield defaultApi(url, method, data);
    yield put({
      type: UPDATE_MEMBER_SUCCESS,
      payload: { data: response, notify: method },
    });
  } catch (err) {
    yield put({
      type: UPDATE_MEMBER_FAILURE,
      payload: err,
    });
  }
}

export function* removeMemberRequest({ payload }) {
  const { organization_id, user_id } = payload;
  try {
    const url = `${organization_id}/members/${user_id}/`;
    const method = 'DELETE';
    const response = yield defaultApi(url, method);
    yield call(getMembersList, { payload });
    yield put({
      type: REMOVE_MEMBER_SUCCESS,
      payload: { data: response, notify: method },
    });
  } catch (err) {
    yield put({
      type: REMOVE_MEMBER_FAILURE,
      payload: err,
    });
  }
}

export function* setPaymentConfigurationRequest({ payload }) {
  try {
    const url = `payroll/paymentsettings/create/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, payload);
    const detailsPayload = {
      organization_id: payload.organization_id,
      user_id: payload.user_id,
    };
    yield call(getMemberDetails, { payload: detailsPayload });
    yield put({
      type: SET_PAYMENT_CONFIGURATION_SUCCESS,
      payload: { data: response, notify: method },
    });
  } catch (err) {
    yield put({
      type: SET_PAYMENT_CONFIGURATION_FAILURE,
      payload: err,
    });
  }
}

export function* updatePaymentConfigurationRequest({ payload }) {
  //const { member_id, ...details } = payload;
  try {
    const url = `payroll/paymentsettings/create/`;
    const method = 'PATCH';
    const response = yield defaultApi(url, method, payload);
    yield put({
      type: UPDATE_PAYMENT_CONFIGURATION_SUCCESS,
      payload: { data: response, notify: method },
    });
  } catch (err) {
    yield put({
      type: UPDATE_PAYMENT_CONFIGURATION_FAILURE,
      payload: err,
    });
  }
}

export function* handleBulkUpdateEmployeeType({ payload }) {
  try {
    const url = '/albait/users-bulk-update/';
    const method = 'POST';
    const response = yield defaultApi(url, method, payload);

    yield put({
      type: BULK_UPDATE_EMPLOYEE_TYPE_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: BULK_UPDATE_EMPLOYEE_TYPE_FAILURE,
      payload: err,
    });
  }
}

export function* getPendingRequestsSaga({ payload }) {
  try {
    const {
      search,
      office_id,
      role,
      user_id,
      name_email,
      organization_id,
      status = 'pending' // Default to 'pending'
    } = payload;

    console.log("Fetching with status:", status);

    // Start with base URL
    let url = `/albait/users-update-requests/`;

    // Add query parameters with proper formatting
    let queryParams = [];

    // Add status filters
    if (status === 'pending') {
      queryParams.push('is_active=True');
      queryParams.push('is_approved=False');
    } else if (status === 'approved') {
      queryParams.push('is_active=True');
      queryParams.push('is_approved=True');
    } else if (status === 'declined') {
      queryParams.push('is_active=False');
      queryParams.push('is_approved=False');
    }

    // Add other filters (excluding page)
    if (search) queryParams.push(`search=${search}`);
    if (office_id) queryParams.push(`office_id=${office_id}`);
    if (role) queryParams.push(`role=${role}`);
    if (user_id) queryParams.push(`user_id=${user_id}`);
    if (name_email) queryParams.push(`name=${name_email}`);

    // Construct final URL with query parameters
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    console.log("Final URL:", url);

    const method = 'GET';
    const response = yield call(defaultApi, url, method);

    yield put({
      type: GET_PENDING_REQUESTS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    console.error("Error fetching pending requests:", err);
    yield put({
      type: GET_PENDING_REQUESTS_FAILURE,
      payload: err,
    });
  }
}

export function* requestUpdateEmployeeTypeSaga({ payload }) {
  try {
    const url = '/albait/users-update-requests/';
    const method = 'POST';
    let count = 0;
    for (let chunk of payload) {
      try {
        const response = yield defaultApi(url, method, chunk);
        count++;
      } catch (err) {
        console.log(err);
      }
    }
    if (count === payload.length) {
      yield put({
        type: REQUEST_UPDATE_EMPLOYEE_TYPE_SUCCESS,
        payload: { data: "all", notify: 'POST' },
      });
    }
    else {
      yield put({
        type: REQUEST_UPDATE_EMPLOYEE_TYPE_SUCCESS,
        payload: { data: "partial", notify: 'POST' },
      });
    }
  } catch (err) {
    yield put({
      type: REQUEST_UPDATE_EMPLOYEE_TYPE_FAILURE,
      payload: { data: "none", notify: 'POST' },
    });
  }
}

export function* bulkUpdateFromPendingRequestsSaga({ payload, status }) {
  if (status === 'approve') {
    let bulkUpdatePayload = {
      update_type: 'partial',
      user_updates: []
    }
    payload.forEach(user => {
      bulkUpdatePayload.user_updates.push({
        user_id: user.user_id,
        fields: {
          user_type: user.user_type,
        }
      })
    })
    const url = '/albait/users-bulk-update/'
    const method = 'POST'

    try {
      let response = yield defaultApi(url, method, bulkUpdatePayload)
      if (response.status === 200) {
        let count = 0
        for (let user of payload) {

          let url = `/albait/users-update-requests/${user.id}/`
          let method = 'PATCH'
          let dataToUpdate = {
            is_active: true,
            is_approved: true
          }
          try {
            let response = yield defaultApi(url, method, dataToUpdate)
            if (response.status === 200) {
              count++
            }
          } catch (err) {
            console.log(err)
          }
        }
        if (count === payload.length) {
          yield put({
            type: BULK_UPDATE_FROM_PENDING_REQUESTS_SUCCESS,
            payload: { data: payload, notify: 'POST' },
          })
        }
        else {
          yield put({
            type: BULK_UPDATE_FROM_PENDING_REQUESTS_SUCCESS,
            payload: { data: payload, notify: 'POST' },
          })
        }
      }
    }
    catch (err) {
      console.log(err)
      yield put({
        type: BULK_UPDATE_FROM_PENDING_REQUESTS_FAILURE,
        payload: { data: err, notify: 'POST' },
      })
    }
  }
  else if (status === 'reject') {
    let count = 0
    for (let user of payload) {
      let url = `/albait/users-update-requests/${user.id}/`
      let method = 'PATCH'
      let dataToUpdate = {
        is_active: false,
      }
      try {
        let response = yield defaultApi(url, method, dataToUpdate)
        if (response.status === 200) {
          count++
        }
      } catch (err) {
        console.log(err)
      }
    }
    if (count === payload.length) {
      yield put({
        type: BULK_UPDATE_FROM_PENDING_REQUESTS_SUCCESS,
        payload: { data: payload, notify: 'POST' },
      })
    }
    else {
      yield put({
        type: BULK_UPDATE_FROM_PENDING_REQUESTS_SUCCESS,
        payload: { data: payload, notify: 'POST' },
      })
    }
  }
}


export default function* root() {
  yield all([
    takeLatest(GET_MEMBERS, getMembersList),
    takeLatest(GET_INVITED_MEMBERS, getInvitedMembersList),
    takeLatest(INVITE_MEMBER, inviteMember),
    takeLatest(DELETE_MEMBER_INVITATION, deleteMemberInvitation),
    takeLatest(GET_MEMBER_DETAILS, getMemberDetails),
    takeLatest(GET_MEMBER_WEEKLY_EARNING, getMemberWeeklyEarning),
    takeLatest(GET_MEMBER_MONTHLY_EARNING, getMemberMonthlyEarning),
    // Create member
    takeLatest(ADD_MEMBER, handleCreateMember),
    takeLatest(UPDATE_MEMBER, updateMemberRequest),
    takeLatest(REMOVE_MEMBER, removeMemberRequest),
    takeLatest(SET_PAYMENT_CONFIGURATION, setPaymentConfigurationRequest),
    takeLatest(UPDATE_PAYMENT_CONFIGURATION, updatePaymentConfigurationRequest),
    takeLatest(BULK_UPDATE_EMPLOYEE_TYPE, handleBulkUpdateEmployeeType),
    takeLatest(GET_PENDING_REQUESTS, getPendingRequestsSaga),
    takeLatest(REQUEST_UPDATE_EMPLOYEE_TYPE, requestUpdateEmployeeTypeSaga),
    takeLatest(BULK_UPDATE_FROM_PENDING_REQUESTS, bulkUpdateFromPendingRequestsSaga),
  ]);
}
